/**
 * Workflows P5-4: how a step was left (path analysis) and the Preview's "simulate the assistant's answer" group.
 * Merged into `engage.workflows.analysis` and `engage.workflows.builder.preview`.
 */
export const workflowsOutcomes = {
  analysis: {
    outcomesTitle: "How visitors left this step",
    startOver: "Start over",
    outcomes: {
      answered: "Answered",
      could_not_answer: "Could not answer",
      asked_for_person: "Asked for a person",
      done: "Finished",
      not_done: "Not finished",
      received: "Call received",
      timed_out: "Timed out",
      replied: "Replied",
      no_reply: "No reply in time",
      invalid: "Answer not accepted",
      woke: "Woke on time",
      interrupted: "Cut short",
      skipped: "Skipped",
      success: "Succeeded",
      failure: "Failed",
    },
  },
  preview: {
    outcome: {
      title: "Simulate how the assistant's answer goes",
      hint: "The run is waiting for the assistant. Choose how its answer goes to follow that exit, or just type a question to let the assistant answer.",
      answered: "Answered",
      could_not_answer: "Could not answer",
      asked_for_person: "Asked for a person",
      applied: "Simulated: {{outcome}}. The workflow went on.",
      failedTitle: "That didn't work",
      failedBody: "The preview may have moved on already. Restart it to try again.",
    },
  },
};
